import type {
  ForgotPasswordRequest,
  LoginRequest,
  LoginResponse,
  RefreshRequest,
  RefreshResponse,
  ResetPasswordRequest,
  User,
} from "@vv/types";
import { apiClient } from "./client/api-client";

export const authApi = {
  login: (payload: LoginRequest) =>
    apiClient.post<LoginResponse>("/auth/login", payload, { skipAuth: true }),

  refresh: (payload: RefreshRequest) =>
    apiClient.post<RefreshResponse>("/auth/refresh", payload, { skipAuth: true }),

  logout: () => apiClient.post<void>("/auth/logout"),

  me: () => apiClient.get<User>("/auth/me"),

  forgotPassword: (payload: ForgotPasswordRequest) =>
    apiClient.post<void>("/auth/forgot-password", payload, { skipAuth: true }),

  resetPassword: (payload: ResetPasswordRequest) =>
    apiClient.post<void>("/auth/reset-password", payload, { skipAuth: true }),

  /**
   * Not a fetch call — the Microsoft SSO flow is a full-page redirect. The
   * backend performs the entire OAuth dance server-side and finally redirects
   * the browser to `${FRONTEND_URL}/sso-callback?accessToken=...&refreshToken=...`.
   */
  microsoftSsoLoginUrl: (apiBaseUrl: string): string =>
    `${apiBaseUrl.replace(/\/+$/, "")}/auth/sso/microsoft/authorize`,
};
